import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogIn, Loader2, AlertTriangle, ShieldCheck } from "lucide-react";
import { useDistributor } from "../context/DistributorContext";

export default function DistributorLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useDistributor();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const next = new URLSearchParams(location.search).get("next") || "/distributor/dashboard";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate(next, { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || "Inloggen mislukt — controleer uw gegevens.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-5 py-12" data-testid="distributor-login-page">
      <div className="rounded-md border border-zinc-200 bg-white p-8 shadow-sm">
        <div className="mb-6 flex items-center gap-2">
          <ShieldCheck className="text-nibro-sage-dark" size={22} />
          <h1 className="font-display text-2xl font-bold text-zinc-900">Distributeur login</h1>
        </div>
        <p className="mb-6 text-sm text-zinc-600">
          Log in om uw eigen distributeurprijzen te zien op alle product pagina's, uw order historie te bekijken en uw persoonlijke prijslijst te downloaden.
        </p>
        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block">
            <span className="text-[11px] font-bold uppercase tracking-wide text-zinc-600">E-mail</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="dist-login-email"
              className="mt-1 w-full rounded border border-zinc-200 px-3 py-2 text-sm focus:border-nibro-sage-dark focus:outline-none"
              autoComplete="email"
            />
          </label>
          <label className="block">
            <span className="text-[11px] font-bold uppercase tracking-wide text-zinc-600">Wachtwoord</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="dist-login-password"
              className="mt-1 w-full rounded border border-zinc-200 px-3 py-2 text-sm focus:border-nibro-sage-dark focus:outline-none"
              autoComplete="current-password"
            />
          </label>
          {error && (
            <div
              className="flex items-start gap-2 rounded bg-aramfix-red/10 px-3 py-2 text-xs font-semibold text-aramfix-red"
              data-testid="dist-login-error"
            >
              <AlertTriangle size={14} className="mt-0.5 flex-shrink-0" />
              <span>{error}</span>
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="dist-login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-nibro-sage-dark px-4 py-3 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-nibro-sage disabled:opacity-60"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : <LogIn size={14} />}
            Inloggen
          </button>
        </form>
        <div className="mt-6 border-t border-zinc-200 pt-4 text-center text-xs text-zinc-600">
          Nog geen distributeur-account?{" "}
          <Link to="/distributor/register" className="font-bold text-nibro-sage-dark hover:underline" data-testid="dist-login-to-register">
            Meld u hier aan
          </Link>
        </div>
      </div>
    </div>
  );
}
